import React, { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { logout, selectUser } from '../../../store/authSlice'
import { ThemeToggler } from '../../ThemeToggler'
import { Icon, LanguagesButton } from '../../../elements'

import './MobileBar.scss'

export const MobileBar = () => {
    const footerRef = useRef(null)
    const { pathname } = useLocation()
    const dispatch = useDispatch()
    const user = useSelector(selectUser)
    const isActive = (path) => pathname === path
    const [isMenuOpen, setIsMenuOpen] = useState(false)


    const handleLogout = async () => {
        dispatch(logout())
        navigate("/auth")
    }

    return (
        <div className={`MobileBar${isMenuOpen ? " open" : ""}`}>
            <div className='content'>
                <Link to="/" className={`link ${isActive("/") ? "active" : ""}`}>
                    <Icon src="/assets/icons/home.svg" className="nav-icon" />
                </Link>
                <Link to="/sites" className={`link ${isActive("/sites") ? "active" : ""}`}>
                    <Icon src="/assets/icons/world.svg" className="nav-icon" />
                </Link>
                {user?.role === "admin" && (
                    <Link to="/users" className={`link ${isActive("/users") ? "active" : ""}`}>
                        <Icon src="/assets/icons/users.svg" className="nav-icon" />
                    </Link>
                )}
                <button className={`link${isMenuOpen ? " active" : ""}`} onClick={() => setIsMenuOpen(!isMenuOpen)}>
                    <Icon src="/assets/icons/menu.svg" className="nav-icon" />
                </button>
            </div>

            <div className='footer' ref={footerRef}>
                <ThemeToggler />
                <div className="user-details">
                    <span className="user-name">{user?.login}</span>
                    <span className="user-role">{user?.role}</span>
                </div>
                <button onClick={handleLogout} className="logout-btn">
                    <Icon src="/assets/icons/logout.svg" className="nav-icon" />
                </button>
            </div>
        </div>
    )
}